import React from 'react';

const sizes = {
  default: `py-3 px-8`,
  lg: `py-4 px-12`,
  xl: `py-5 px-16 text-lg`
};

const Button = ({ children, className = '', size }) => {
  return (
    <button
      type="button"
      className={`
        ${sizes[size] || sizes.default}
        ${className}
        bg-primary
        hover:bg-primary-darker
        rounded-lg
        text-white
        font-medium
        transition-all
        duration-300
        transform
        hover:scale-105
        focus:outline-none
        focus:ring-2
        focus:ring-purple-500
        focus:ring-opacity-50
        disabled:opacity-50
        disabled:cursor-not-allowed
        disabled:transform-none
    `}
    >
      {children}
    </button>
  );
};

export default Button;
